import { useEffect, useState } from "react";
import { useLocalizedLabels } from "widget-shared-components-library";
import mapping from "../../../config/mapping";
import TabsAndSortingLabels from "../../ui/TabsAndSorting/TabsAndSortingLabels";

const useTabAndSorting = (
  devicesItems,
  rateplansItems,
  articlesItems,
  supportItems,
  setCurrentPage,
  search,
  updateURL,
  setSelectedProductsSorting,
  setSelectedProductsPerPage,
  selectedProductsSorting,
  productSorting,
  selectedProductsPerPage,
  setFiltersReady,
  onTabSelection,
  clearFilters = () => {}
) => {
  const labels = useLocalizedLabels(TabsAndSortingLabels);

  const [selectedProductsSortingLabel, setSelectedProductsSortingLabel] =
    useState("");

  useEffect(() => {
    handleProductsSortingChange(productSorting, selectedProductsSorting);
  }, [productSorting, selectedProductsSorting]);

  // Tabs
  const tabs = mapping.getTabs(
    labels,
    devicesItems,
    rateplansItems,
    articlesItems,
    supportItems,
  );

  // Product per page dropdown
  const productsPerPage = mapping.getProductsPerPage(labels);

  // Handles dropdown option change by setting the selected option
  const handleProductsPerPageChange = (selectedOption) => {
    setSelectedProductsPerPage(selectedOption);
    setCurrentPage(1);
    updateURL("size", selectedOption?.value);
  };

  // Handles dropdown option change by setting the selected option
  const handleSortingOptionChange = (
    selectedOptionValue,
    selectedOptionKey,
  ) => {
    setSelectedProductsSorting(selectedOptionKey);
    setCurrentPage(1);
    updateURL("sort", selectedOptionKey);
  };

  const changeTab = (
    id,
    selectedProductsPerPage,
    selectedProductsSorting,
    currentPage,
  ) => {
    setFiltersReady(false);
    clearFilters();
    onTabSelection(
      id,
      selectedProductsPerPage,
      selectedProductsSorting,
      currentPage,
    );
  };

  const handleProductsSortingChange = (
    productSorting,
    selectedProductsSorting,
  ) => {
    if (
      Array.isArray(productSorting) &&
      typeof selectedProductsSorting == "string" &&
      selectedProductsSorting !== ""
    ) {
      const itemLabel = productSorting.find(
        (it) => it.id === selectedProductsSorting,
      )?.label;
      if (typeof itemLabel == "string" && itemLabel !== "") {
        setSelectedProductsSortingLabel(itemLabel);
        return;
      }
    }
    if (selectedProductsSortingLabel !== "") {
      setSelectedProductsSortingLabel("");
    }
  };

  return {
    tabs,
    productsPerPage,
    handleProductsPerPageChange,
    handleSortingOptionChange,
    selectedProductsPerPage,
    selectedProductsSorting,
    labels,
    changeTab,
    selectedProductsSortingLabel,
  };
};
export default useTabAndSorting;
